<template>
  <div id="app">
    <Home />
  </div>
</template>

<script>
import "./assets/css/cssreset.css";
import "./assets/css/common.scss";
import Home from "./view/Home";

export default {
  name: "App",
  components: { Home },
};
</script>

<style>
#app {
  width: 100%;
  height: 100%;
}
</style>
